import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';

import { AddPromotionStepperFC, AddPromotionStepperFCProps } from './AddPromotionStepperFC';

const useStrings = (): AddPromotionStepperFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      type: intl.formatMessage({ id: $tk.components.AddPromotionStepper.type }),
      details: intl.formatMessage({ id: $tk.components.AddPromotionStepper.details }),
      review: intl.formatMessage({ id: $tk.components.AddPromotionStepper.review }),
    }),
    [intl],
  );
};

type AddPromotionStepperProps = Omit<AddPromotionStepperFCProps, 'strings'>;

export function AddPromotionStepper(props: AddPromotionStepperProps) {
  const strings = useStrings();
  return <AddPromotionStepperFC {...props} strings={strings} />;
}
